module.exports = __webpack_public_path__ + "img/box_roxo_sombra.1179f33e.png";